import { render, staticRenderFns } from "./Python.vue?vue&type=template&id=0a8ec535&scoped=true&"
import script from "./Python.vue?vue&type=script&lang=js&"
export * from "./Python.vue?vue&type=script&lang=js&"
import style0 from "./Python.vue?vue&type=style&index=0&id=0a8ec535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ec535",
  null
  
)

export default component.exports